export default function getPlural( name: string): string {
    const last = name.slice(-1)
    return last === "y" 
        ?
        name.substring(0, name.length - 1) + "ies"
        :
        last === "s"
            ?
            name + "es"
            :
            name + "s"
}